import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./ClientsSection.scss";


function ClientsSection4(props) {
  const items = [
    {
      name: "JavaScript",
      image: "js_logo.svg",
      width: "100px",
    },
    {
      name: "React.js",
      image: "react_logo.svg",
      width: "200px",
    },
    {
      name: "Node.js",
      image: "nodejs_logo.svg",
      width: "200px",
    },
    {
      name: "TypeScript",
      image: "typescript_logo.svg",
      width: "100px",
    },
    {
      name: "Go",
      image: "go_logo.svg",
      width: "200px",
    },
    {
      name: "Rust",
      image: "rust_logo.svg",
      width: "200px",
    },
    {
      name: "Elixir",
      image: "elixir_logo.svg",
      width: "200px",
    },
    {
      name: "PostgresDB",
      image: "postgres_logo.svg",
      width: "200px",
    },
    {
      name: "Redis",
      image: "redis_logo.svg",
      width: "200px",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-multiline">
          {items.map((item, index) => (
            <div className="column is-narrow has-text-centered" key={index}>
              <div className="ClientsSection__logo">
                <img src={item.image} width={item.width} alt={item.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default ClientsSection4;
